/**
* @ class State model declaration for store admin User related fields
**/
export interface UpdateState {
  isUpdated: string;
}
/**
* @ class Initial State model for admin store
**/
export const initialUpdateState: UpdateState = {
  isUpdated: ''
};
